import { useRecordContext } from "react-admin";

const VideoField = (props) => {
  const record = useRecordContext(props);

  return (
    <video src={`${record.originalURL ?? record.src}`} controls width="320" height="240"></video>
  );
};

export default VideoField;
